var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCompass1 = function SvgCompass1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#compass1_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    d: "M14.665 8A6.667 6.667 0 0 1 8 14.667M14.665 8A6.667 6.667 0 0 0 8 1.333M14.665 8h-1.333m-5.333 6.667A6.667 6.667 0 0 1 1.332 8m6.667 6.667v-1.334M1.332 8a6.667 6.667 0 0 1 6.667-6.667M1.332 8h1.333M8 1.333v1.334m4.714 10.047-.943-.943M4.227 4.23l-.942-.943m8.485.943.943-.943m-9.428 9.428.942-.943M5.332 8l1.667-1 1-1.667 1 1.667 1.666 1L9 9l-1 1.667-1-1.667z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "compass1_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#fff"
  })))));
};
export default SvgCompass1;